import React, { Component } from "react";
import { Alert, Button, Spin } from "antd";
import ReCAPTCHA from "react-google-recaptcha";

import { PostData } from "../../api/service";
import { RECAPTCHA_SITE_KEY, isValidEmail } from "../../Helper/GlobalConstants";

/**
 * Step 1 — find the student's existing record so step 2 can be prefilled.
 *
 * The lookup needs the roll number AND the email together: roll numbers repeat
 * across sessions, so the email is what makes the pair specific. Roughly 40% of
 * student rows cannot be matched at all (no roll number on file, or no email),
 * which is why a failed lookup is not a dead end — the student continues with a
 * blank form and the office links the request by hand later.
 */
export default class IdCardIdentifyStep extends Component {
  state = {
    roll_no: "",
    email: "",
    recaptcha_token: "",
    isLoading: false,
    message: "",
    messageType: "error"
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }

    if (this.state.roll_no.trim() === "") {
      this.setState({ message: "Please enter your roll number", messageType: "error" });
      return;
    }

    if (!isValidEmail(this.state.email)) {
      this.setState({ message: "Please enter a valid email address", messageType: "error" });
      return;
    }

    if (this.state.recaptcha_token === "") {
      this.setState({ message: "Please complete the captcha", messageType: "error" });
      return;
    }

    this.setState({ isLoading: true, message: "" });

    PostData("/lookup-student-for-id-card", {
      roll_no: this.state.roll_no,
      email: this.state.email,
      recaptcha_token: this.state.recaptcha_token
    })
      .then((resp) => {
        this.setState({ isLoading: false });

        if (resp && resp.status === true) {
          this.props.onFound(resp, this.state.roll_no, this.state.email);
        } else {
          this.setState({
            message:
              resp && resp.status_text
                ? resp.status_text
                : "We could not find your record.",
            messageType: "warning"
          });
        }
      })
      .catch(() => {
        this.setState({
          isLoading: false,
          message: "Something went wrong. Please try again.",
          messageType: "error"
        });
      });
  };

  onContinueBlank = () => {
    this.props.onSkip(this.state.roll_no, this.state.email);
  };

  render() {
    return (
      <div>
        <p>
          Enter your roll number and the email address the college has on record.
          We will fetch whatever details we already hold so you only need to fill
          in what is missing.
        </p>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Roll Number *</label>
              <input
                type="text"
                className="form-control"
                name="roll_no"
                maxLength={50}
                value={this.state.roll_no}
                onChange={this.onChange}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>Email *</label>
              <input
                type="email"
                className="form-control"
                name="email"
                maxLength={50}
                value={this.state.email}
                onChange={this.onChange}
              />
            </div>
          </div>
        </div>

        <ReCAPTCHA
          sitekey={RECAPTCHA_SITE_KEY}
          onChange={(token) => this.setState({ recaptcha_token: token || "" })}
        />
        <br />

        {this.state.message !== "" && (
          <div>
            <Alert
              type={this.state.messageType}
              message={this.state.message}
              showIcon
            />
            <br />
          </div>
        )}

        {this.state.isLoading ? (
          <Spin />
        ) : (
          <div>
            <Button type="primary" onClick={this.onSubmit}>
              Continue
            </Button>
            &nbsp;&nbsp;
            {this.state.messageType === "warning" && this.state.message !== "" && (
              <Button onClick={this.onContinueBlank}>
                Continue anyway and fill in myself
              </Button>
            )}
          </div>
        )}
      </div>
    );
  }
}
